var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLossUpmeterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1504 1.36856C4.54156 0.738467 5.45844 0.738466 5.8496 1.36856L9.24793 6.84269C9.66147 7.50884 9.1824 8.37012 8.39833 8.37012H1.60167C0.817595 8.37012 0.338527 7.50884 0.752072 6.84269L4.1504 1.36856Z",
    fill: "#FF5858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossUpmeterIcon);
export default __webpack_public_path__ + "static/media/lossUpmeterIcon.9b5df2b5e6fb31e74dc36b911d4a7a5b.svg";
export { ForwardRef as ReactComponent };